/*
------------------------------------------------
Delishop Framework
FAQ Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initFaq(section) {

        if (!section) return;

        // Reservado para futuras mejoras.
        // Esta versión mantiene el FAQ completamente estático.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".dh-faq")
            .forEach(initFaq);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-faq");

        if (section) {

            initFaq(section);

        }

    });

})();